import { Box, TextField } from "@mui/material";
import PageTitleSubtitle from "../PageTitleSubTitle";
import { getInputLabelProps, getInputProps } from "../../common/appStyles";

export default function FieldTextField({
  fieldTitle,
  fieldSubtitle,
  fieldName,
  handleValueChange,
  fieldValue,
  isRequired,
  customMinWidth,
  customComponent,
}) {
  return (
    <div className="w-full flex justify-between items-center my-2 gap-2">
      <div>
        <PageTitleSubtitle
          useFieldTitleStyle
          useEventTitleStyle
          title={isRequired ? `${fieldTitle} *` : fieldTitle}
          subtitle={fieldSubtitle}
        />
      </div>

      {customComponent ? (
        <Box
          sx={
            customMinWidth
              ? { minWidth: customMinWidth, maxWidth: customMinWidth }
              : { minWidth: "250px" }
          }
        >
          {customComponent}
        </Box>
      ) : (
        <TextField
          required={isRequired}
          name={fieldName}
          onChange={handleValueChange}
          value={fieldValue}
          style={{ minWidth: customMinWidth ?? "250px" }}
          size="small"
          InputLabelProps={getInputLabelProps()}
          inputProps={getInputProps()}
        />
      )}
    </div>
  );
}
